module.exports = __webpack_public_path__ + "static/media/er.ed8466e0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/er.svg
// module id = 1226
// module chunks = 0